import React, { Fragment } from "react"

import {
  Container,
  Row,
  Left,
  Right,
  StyledGrid,
  BigCard,
  SmallCard,
  SmallCardTablet,
  MobileWrapper,
  Scroll,
  ScrollContainer,
  ScrollableGrid,
  MobileCard,
  Line,
} from "./styles"

const Grid1 = ({ articles, pageType }) => {
  if (articles.length === 0) {
    return null
  }

  return (
    <>
      <Container>
        <Row>
          <Left>
            <BigCard
              {...articles[0]}
              variant="2col"
              headlineVariant="xlarge"
              imagePosition="bottom"
              pageType={pageType}
              pageSection="featured"
              clickPosition={0}
            />
          </Left>
          <Right>
            <StyledGrid
              numColumns={{
                default: 1,
                desktopL: 1,
                hamburgerLarge: 3,
                desktop: 3,
                tablet: 2,
              }}
              rowMargin="2rem !important"
              colMargin="2rem"
            >
              {articles.slice(1, 4).map((article, idx) => (
                <Fragment key={`category-article-card-desktop-${article.id}`}>
                  <SmallCard
                    {...article}
                    variant="4col"
                    headlineVariant="medium"
                    imagePosition="left"
                    pageType={pageType}
                    pageSection="featured"
                    clickPosition={idx + 1}
                  />
                  <SmallCardTablet
                    {...article}
                    variant="3col"
                    headlineVariant="medium"
                    pageType={pageType}
                    pageSection="featured"
                    clickPosition={idx + 1}
                  />
                </Fragment>
              ))}
            </StyledGrid>
          </Right>
        </Row>
      </Container>
      <MobileWrapper>
        <BigCard
          {...articles[0]}
          variant="2col"
          headlineVariant="large"
          imagePosition="bottom"
          pageType={pageType}
          pageSection="featured"
          clickPosition={0}
          tracking={["View", "Click"]}
        />
        <Scroll />
        <ScrollContainer>
          <ScrollableGrid>
            {articles.slice(1).map((article, idx) => (
              <MobileCard
                key={`category-article-card-mobile-${article.id}`}
                {...article}
                variant="4col"
                headlineVariant="small"
                pageType={pageType}
                pageSection="featured"
                clickPosition={idx + 1}
                tracking={["View", "Click"]}
              />
            ))}
          </ScrollableGrid>
        </ScrollContainer>
        <Line />
      </MobileWrapper>
    </>
  )
}

export default Grid1
